import {field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";

export class InventoryGroupData extends LocalisableEntityData<InventoryGroupData> {
    @identifier invGroupId: number;
    @field name: string;
    @field nonStockable: boolean;

}
